<template>
    <DModal
        :show="showModal"
        :title="title"
        is-big
        is-confirm
        :is-awaiting-validation="true"
        @confirm="confirm"
        @close="close"
    >
        <div class="p-3">
            <DFormRow
                :label="__('orders.note.label')"
                :is-required="true"
                :error="errors.note"
            >
                <DFormTextarea
                    v-model="form.note"
                    rows="5"
                    :is-valid="isFormFieldValid('note')"
                />
            </DFormRow>
        </div>
    </DModal>
</template>

<script>
export default {
    name: 'OrderNoteCreateModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        orderNote: {
            type: Object,
            default: () => ({})
        },
        errors: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['close-modal', 'confirm'],
    data () {
        return {
            form: this.$inertia.form({
                id: this.orderNote.id ?? null,
                note: this.orderNote.note ?? null
            })
        }
    },
    methods: {
        confirm () {
            this.$emit('confirm', this.form)
        },
        close () {
            this.$emit('close-modal')
        }
    }
}
</script>

<style scoped>

</style>
